module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "node": "out-in"
    }
  }, [(_vm.isMobile && _vm.gameStart) ? _c('game', {
    on: {
      "game-end": function($event) {
        _vm.gameStart = false
      }
    }
  }) : _c('div', {
    staticClass: "app-wrap"
  }, [(!_vm.isHeaderHidden) ? _c('header-bar', {
    attrs: {
      "slideLeft": _vm.slideLeft
    },
    on: {
      "game-start": function($event) {
        _vm.gameStart = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "transition-wrap"
  }, [_c('transition', {
    attrs: {
      "name": _vm.slideLeft ? 'slide-fade-left' : 'slide-fade-right',
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "content"
  })], 1)], 1), _vm._v(" "), (!_vm.isFooterHidden) ? _c('footer-bar') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4f3676","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 827
// module chunks = 16